
// 30 days cookie expiry
const cookieExpiryDays = 30;
const cookieName = 'disclaimerModalAccepted';

const root = document.getElementById('js-disclaimer-modal');
const showAlways = root ? !!root.getAttribute('data-showalways') : false;

function toggle(targetState) {
  if (targetState) {
    if (root) {
      root.classList.remove('disclaimer-modal--hidden');
    } else {
      const expiry = new Date();
      expiry.setDate(expiry.getDate() - 1);
      document.cookie = `${cookieName}=false; expires=${expiry.toUTCString()}; path=/`;
    }
  } else {
    root.classList.add('disclaimer-modal--hidden');
  }
}

let captureBackButton = false;

const triggerButtons = Array.from(document.querySelectorAll('.js-disclaimer-modal-trigger, .disclaimer-modal--trigger-root a[href]'));
triggerButtons.forEach((trigger) => {
  trigger.addEventListener('click', (ev) => {
    if (!root) {
      const expiry = new Date();
      expiry.setDate(expiry.getDate() - 1);
      document.cookie = `${cookieName}=false; expires=${expiry.toUTCString()}; path=/`;
      return;
    }
    toggle(true);
    acceptAction = () => {
      window.location.href = trigger.href;
    };
    captureBackButton = true;
    ev.preventDefault();
  });
});

if (root) {
  if (document.cookie.indexOf(`${cookieName}=`) !== -1 && !showAlways) {
    toggle(false);
  } else {
    toggle(true);
  }
  const acceptButton = document.getElementById('js-disclaimer-modal-accept');
  acceptButton.addEventListener('click', () => {
    toggle(false);
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + cookieExpiryDays);
    document.cookie = `${cookieName}=true; expires=${expiry.toUTCString()}; path=/`;
  });

  const backButton = document.getElementById('js-disclaimer-modal-back');
  backButton.addEventListener('click', (ev) => {
    if (captureBackButton) {
      ev.preventDefault();
      toggle(false);
      captureBackButton = false;
    }
  });
}
